// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Option_wrapper__dfajS","hideInfo":"Option_hideInfo__Mzh0q","name":"Option_name__YAeq4","info":"Option_info__PNeYz"};